import { DocumentReference, DocumentData } from "@angular/fire/firestore";
import { EmailRecipient } from "./email.model";

export class EmailRecipientBuilder {
  public reference: DocumentReference;
  public name: string;
  public email: string;
  public phone: string;
  public description: string;
  public cities: string[];
  public venues: string[];
  public createdBy: string;
  public editedBy: string;
  public hasFullAccess: boolean;
  constructor() {}

  /******************************************************
   * INITIALIZATION FUNCTIONS ***************************
   *****************************************************/
  edit(email: EmailRecipient) {
    this.reference = email.reference;
    this.name = email.name;
    this.email = email.email;
    this.phone = email.phone;
    this.description = email.description;
    this.cities = email.cities;
    this.venues = email.venues;
    this.createdBy = email.createdBy;
    this.editedBy = email.editedBy;
    this.hasFullAccess = email.hasFullAccess;
    return this;
  }

  load(data: DocumentData, ref: DocumentReference): EmailRecipientBuilder {
    this.reference = ref;
    this.name = data.name;
    this.email = data.email;
    this.phone = data.phone;
    this.description = data.description;
    this.cities = data.cities;
    this.venues = data.venues;
    this.createdBy = data.createdBy;
    this.editedBy = data.editedBy;
    this.hasFullAccess = data.hasFullAccess;
    return this;
  }

  build(): EmailRecipient {
    return new EmailRecipient(this);
  }

  /******************************************************
   * GETTER/SETTER FUNCTIONS ****************************
   *****************************************************/

  setName(name: string): EmailRecipientBuilder {
    this.name = name;
    return this;
  }

  setEmail(email: string): EmailRecipientBuilder {
    this.email = email;
    return this;
  }

  setPhone(phone: string): EmailRecipientBuilder {
    this.phone = phone;
    return this;
  }

  setDescription(description: string): EmailRecipientBuilder {
    this.description = description;
    return this;
  }

  setCities(cities: string[]): EmailRecipientBuilder {
    this.cities = cities;
    return this;
  }

  setVenues(venues: string[]): EmailRecipientBuilder {
    this.venues = venues;
    return this;
  }

  setAccess(hasFullAccess: boolean): EmailRecipientBuilder {
    this.hasFullAccess = hasFullAccess;
    return this;
  }

  setEditedBy(editedBy: string) {
    this.editedBy = editedBy;
    return this;
  }

  setCreatedBy(createdBy: string) {
    this.createdBy = createdBy;
    return this;
  }
}
